import { typedStyles } from '@/utils/styleUtils';

import { APP_ZOOM } from '@/styles/portalLayout';

export const styles = typedStyles({
  /**
   * Popper rule. `zoom: APP_ZOOM` puts back the 85% size the counter-zoom container removed.
   * Colors, typography, padding and radius stay the MUI theme's tooltip look.
   */
  tooltipPopper: {
    '& .MuiTooltip-tooltip': {
      zoom: APP_ZOOM,
    },
  },
});
